var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-footer",style:({ color: _vm.color })},[_vm._m(0),_c('div',[_c('span',[_vm._v(_vm._s(_vm.time))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("创新业务中心技术支持")])])
}]

export { render, staticRenderFns }